import partialMap from './partials';
//a list of partials that is always included in the XML for development purposes
const devPartials = [];

function getDevPartialMap() {
    if (devPartials.length > 0) {
        console.warn("Dev Partials are present, please make sure to remove them from assets/devPartials and test them before releasing");
    }
    const returnMap = new Map();
    devPartials.forEach(element => {
        if (!element.startsWith('partials/')) {
            throw new Error("non-partial element in DevPartials.js");
        }
        let key = element;
        //cut html extension if needed
        if (element.endsWith('.html')) {
            key = element.slice(0, -5);
        }
        if (partialMap.has(key)) {
            returnMap.set(key, partialMap.get(key));
        } else {
            console.warn(`devPartial '${key}.html' is not defined in assets/partials, will be generated as empty`);
            returnMap.set(key, {});
        }
    });
    return returnMap;
}

export default getDevPartialMap;